import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { HugeiconsIconComponent } from '@hugeicons/angular';
import { UserIcon, PencilEdit01Icon, Camera01Icon, Cancel01Icon } from '@hugeicons/core-free-icons';

@Component({
    selector: 'app-profile-image-upload',
    standalone: true,
    imports: [HugeiconsIconComponent],
    templateUrl: './profile-image-upload.component.html',
    styleUrl: './profile-image-upload.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ProfileImageUploadComponent),
            multi: true
        }
    ]
})
export class ProfileImageUploadComponent implements ControlValueAccessor {
    @Input() size: number = 100; // Size in pixels
    @Input() label: string = 'Profile Image';
    @Input() placeholderIcon: any = UserIcon;

    // Icons
    editIcon = PencilEdit01Icon;
    cameraIcon = Camera01Icon;
    closeIcon = Cancel01Icon;

    previewUrl: string | null = null;
    isHovered = false;

    onChange: any = () => { };
    onTouched: any = () => { };

    onFileSelected(event: any) {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                this.previewUrl = reader.result as string;
                this.onChange(file); // Emit the File object
            };
            reader.readAsDataURL(file);
        }
    }

    removeImage(event: MouseEvent) {
        event.stopPropagation();
        this.previewUrl = null;
        this.onChange(null);
    }

    // ControlValueAccessor methods
    writeValue(value: any): void {
        if (value instanceof File) {
            const reader = new FileReader();
            reader.onload = () => {
                this.previewUrl = reader.result as string;
            };
            reader.readAsDataURL(value);
        } else if (typeof value === 'string') {
            this.previewUrl = value;
        } else {
            this.previewUrl = null;
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
}
